'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasePatternFactory = require('../lib/BasePatternFactory');

var _BasePatternFactory2 = _interopRequireDefault(_BasePatternFactory);

var _HexCodeRegex = require('../regex/HexCodeRegex');

var _HexCodeRegex2 = _interopRequireDefault(_HexCodeRegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HexCodePattern = (0, _BasePatternFactory2.default)({
  name: 'HexCode',
  validator: function validator(input) {
    return _HexCodeRegex2.default.test(input);
  }
});

HexCodePattern.toRGB = function (input) {
  var matchedGroups = _HexCodeRegex2.default.exec(input);
  var RGB = null;
  if (matchedGroups && matchedGroups.length === 7) {
    if (matchedGroups[1] !== undefined) {
      RGB = {
        r: parseInt(matchedGroups[1], 16),
        g: parseInt(matchedGroups[2], 16),
        b: parseInt(matchedGroups[3], 16)
      };
    }
    if (matchedGroups[4] !== undefined) {
      RGB = {
        r: parseInt(matchedGroups[4] + matchedGroups[4], 16),
        g: parseInt(matchedGroups[5] + matchedGroups[5], 16),
        b: parseInt(matchedGroups[6] + matchedGroups[6], 16)
      };
    }
  }

  return RGB;
};

exports.default = HexCodePattern;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PatternValidationJS/static-1.103/js/patterns/HexCode.js
// module id = 927
// module chunks = 2 3